/*
 * 订单管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
// import Test0Empty from '@/views/test/empty.vue';
export default {
  path: 'after',
  name: 'BusinessAfter',
  component: EmptyRouterAlive,
  meta: {
    title: '售后管理',
  },
  // eslint-disable-next-line no-sparse-arrays
  children: [
    /** 退货单客户端 */
    {
      path: 'return',
      name: 'BusinessAfterCsgReturnIndex',
      component: EmptyRouter,
      redirect: 'return/index',
      meta: {
        title: '退货单',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessAfterCsgReturnIndex',
          component: () => import('@/views/center-business/after/csg-return/index'),
          meta: {
            title: '退货单',
            isCache: true
          },
        },
        {
          path: 'view',
          name: 'BusinessAfterReturnView',
          component: () => import('@/views/center-business/after/csg-return/view'),
          meta: {
            title: '退货单详情',
            isCache: true
          },
          hidden: true,
        },
        {
          path: 'add',
          name: 'BusinessAfterCsgReturnAdd',
          component: () => import('@/views/center-business/after/csg-return/add'),
          meta: {
            title: '新增退货单',
            isCache: true
          },
          hidden: true,
        },
        {
          path: 'edit',
          name: 'BusinessAfterCsgReturnEdit',
          component: () => import('@/views/center-business/after/csg-return/edit'),
          meta: {
            title: '编辑退货单',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    /** 退货单admin端 */
    {
      path: 'return',
      name: 'BusinessAfterCsgAdminReturnIndex',
      component: EmptyRouter,
      redirect: 'csg-admin-return/index',
      meta: {
        title: '退货单',
      },
      children: [
        {
          path: 'csg-admin-return/index',
          name: 'BusinessAfterCsgAdminReturnIndex',
          component: () => import('@/views/center-business/after/csg-admin-return/index'),
          meta: {
            title: '退货单',
            isCache: true
          },
        },
        {
          path: 'csg-admin-return/view',
          name: 'BusinessAfterCsgAdminReturnView',
          component: () => import('@/views/center-business/after/csg-admin-return/view'),
          meta: {
            title: '退货单详情',
            isCache: true
          },
          hidden: true,
        },
        {
          path: 'csg-admin-return/add',
          name: 'BusinessAfterCsgAdminReturnAdd',
          component: () => import('@/views/center-business/after/csg-admin-return/add'),
          meta: {
            title: '新增退货单',
            isCache: true
          },
          hidden: true,
        },
        {
          path: 'csg-admin-return/edit',
          name: 'BusinessAfterCsgAdminReturnEdit',
          component: () => import('@/views/center-business/after/csg-admin-return/edit'),
          meta: {
            title: '编辑退货单',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    /** 退件列表 */
    // {
    //   path: 'returnList',
    //   name: 'BusinessAfterReturnList',
    //   component: EmptyRouter,
    //   redirect: 'return/list',
    //   meta: {
    //     title: '退件列表',
    //   },
    //   children: [
    //     {
    //       path: 'return/list',
    //       name: 'BusinessAfterReturnList',
    //       component: () => import('@/views/center-business/after/return/list'),
    //       meta: {
    //         title: '退件列表',
    //         isCache: true
    //       },
    //     },
    //     {
    //       path: 'return/view',
    //       name: 'BusinessAfterReturnView',
    //       component: () => import('@/views/center-business/after/return/view'),
    //       meta: {
    //         title: '退件详情',
    //         isCache: true
    //       },
    //       hidden: true,
    //     },
    //     {
    //       path: 'return/confim',
    //       name: 'BusinessAfterReturnConfim',
    //       component: () => import('@/views/center-business/after/return/confim'),
    //       meta: {
    //         title: '仓库人员确认',
    //         isCache: true
    //       },
    //     },
    //     {
    //       path: 'return/add',
    //       name: 'BusinessAfterReturnAdd',
    //       component: () => import('@/views/center-business/after/return/add'),
    //       meta: {
    //         title: '新增退件',
    //         isCache: true
    //       },
    //       hidden: true,
    //     },
    //     {
    //       path: 'return/edit',
    //       name: 'BusinessAfterReturnEdit',
    //       component: () => import('@/views/center-business/after/return/edit'),
    //       meta: {
    //         title: '编辑退件',
    //         isCache: true
    //       },
    //       hidden: true,
    //     },
    //   ],
    // },
    {
      path: 'openReturnList',
      name: 'BusinessOpenReturnList',
      component: EmptyRouter,
      redirect: 'openReturn/list',
      meta: { title: '未完成退件', isCache: true },
      children: [
        {
          path: 'openReturn/list',
          name: 'BusinessOpenReturnList',
          component: () => import('@/views/center-business/after/openReturn/list'),
          meta: {
            title: '未完成退件',
            isCache: true
          },
        },
        {
          path: 'openReturn/view',
          name: 'BusinessAfterReturnView',
          component: () => import('@/views/center-business/after/openReturn/view'),
          meta: {
            title: '退件详情',
            isCache: true
          },
          hidden: true,
        },
        {
          path: 'openReturn/confim',
          name: 'BusinessAfterReturnConfim',
          component: () => import('@/views/center-business/after/openReturn/confim'),
          meta: {
            title: '仓库人员确认',
            isCache: true
          },
        },
        {
          path: 'openReturn/add',
          name: 'BusinessAfterReturnAdd',
          component: () => import('@/views/center-business/after/openReturn/add'),
          meta: {
            title: '新增退件',
            isCache: true
          },
          hidden: true,
        },
        {
          path: 'openReturn/edit',
          name: 'BusinessAfterReturnEdit',
          component: () => import('@/views/center-business/after/openReturn/edit'),
          meta: {
            title: '编辑退件',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'closeReturnList',
      name: 'BusinessCloseReturnList',
      component: EmptyRouter,
      redirect: 'closeReturn/list',
      meta: { title: '已完成退件', isCache: true },
      children: [
        {
          path: 'closeReturn/list',
          name: 'BusinessCloseReturnList',
          component: () => import('@/views/center-business/after/closeReturn/list'),
          meta: {
            title: '已完成退件',
            isCache: true
          },
        },
        {
          path: 'closeReturn/view',
          name: 'BusinessAfterReturnView',
          component: () => import('@/views/center-business/after/closeReturn/view'),
          meta: {
            title: '退件详情',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
  ],
};
